import type {
  GenerateAltTextResponse,
  MLAsset
} from "./ddc-pages-alt-text-manager-interface";

export const mockMLAssetWithoutAltText: MLAsset = {
  id: "asset-1",
  libraryId: "library-1",
  thumbName:
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==",
  name: "https://pictures-np.dealer.com/test/image1.jpg",
  label: "2024 Honda Civic",
  altText: null,
  mimeType: "image/jpeg",
  height: 1080,
  width: 1920,
  fileSize: 245678,
  status: 1,
  created: "2024-01-15T10:30:00Z",
  createdBy: "2024-01-15T10:30:00Z"
};

export const mockMLAssetWithAltText: MLAsset = {
  id: "asset-2",
  libraryId: "library-1",
  thumbName:
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==",
  name: "https://pictures-np.dealer.com/test/image2.jpg",
  label: "2023 Toyota Camry",
  altText: "Silver 2023 Toyota Camry sedan parked in dealership lot",
  mimeType: "image/jpeg",
  height: 1080,
  width: 1920,
  fileSize: 312456,
  status: 1,
  created: "2024-01-14T09:15:00Z",
  createdBy: "2024-01-14T09:15:00Z"
};

export const mockMLAssetWithEmptyAltText: MLAsset = {
  id: "asset-3",
  libraryId: "library-1",
  thumbName:
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==",
  name: "https://pictures-np.dealer.com/test/image3.jpg",
  label: "2024 Ford F-150",
  altText: "",
  mimeType: "image/jpeg",
  height: 1080,
  width: 1920,
  fileSize: 289123,
  status: 1,
  created: "2024-01-13T14:20:00Z",
  createdBy: "2024-01-13T14:20:00Z"
};

export const mockMLAsset4: MLAsset = {
  id: "asset-4",
  libraryId: "library-2",
  thumbName:
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==",
  name: "https://pictures-np.dealer.com/test/image4.jpg",
  label: "2024 BMW X5",
  altText: null,
  mimeType: "image/png",
  height: 1080,
  width: 1920,
  fileSize: 412890,
  status: 1,
  created: "2024-01-12T11:45:00Z",
  createdBy: "2024-01-12T11:45:00Z"
};

export const mockMLAsset5: MLAsset = {
  id: "asset-5",
  libraryId: "library-2",
  thumbName:
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==",
  name: "https://pictures-np.dealer.com/test/image5.jpg",
  label: "2023 Tesla Model 3",
  altText: null,
  mimeType: "image/jpeg",
  height: 1080,
  width: 1920,
  fileSize: 198234,
  status: 1,
  created: "2024-01-11T08:00:00Z",
  createdBy: "2024-01-11T08:00:00Z"
};

export const mockMLAssetsSmall: MLAsset[] = [
  mockMLAssetWithoutAltText,
  mockMLAssetWithAltText,
  mockMLAssetWithEmptyAltText
];

export const mockMLAssetsLarge: MLAsset[] = [
  mockMLAssetWithoutAltText,
  mockMLAssetWithAltText,
  mockMLAssetWithEmptyAltText,
  mockMLAsset4,
  mockMLAsset5,
  ...Array.from({ length: 20 }, (_, i) => ({
    id: `asset-${i + 6}`,
    libraryId: "library-3",
    thumbName:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==",
    name: `https://pictures-np.dealer.com/test/image${i + 6}.jpg`,
    label: `Test Vehicle ${i + 6}`,
    altText: null,
    mimeType: "image/jpeg",
    height: 1080,
    width: 1920,
    fileSize: 200000 + i * 1000,
    status: 1,
    created: `2024-01-${10 - (i % 10)}T10:00:00Z`,
    createdBy: `2024-01-${10 - (i % 10)}T10:00:00Z`
  }))
];

export const mockGenerateAltTextResponse: GenerateAltTextResponse = {
  imageName: "https://pictures-np.dealer.com/test/image1.jpg",
  altText: "White 2024 Honda Civic sedan showcased in dealership showroom"
};
